import React__default, { Fragment } from 'react';
import PropTypes from 'prop-types';
import InputLabel from './InputLabel.js';
import InputField from './Input.js';

var InputWithLabel = function InputWithLabel(_ref) {
  var name = _ref.name,
    label = _ref.label,
    placeholder = _ref.placeholder,
    errors = _ref.errors,
    touched = _ref.touched,
    type = _ref.type,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    size = _ref.size,
    fw = _ref.fw,
    value = _ref.value;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(InputLabel, {
    touched: touched,
    errors: errors,
    field: name,
    name: name,
    size: size
  }, label), /*#__PURE__*/React__default.createElement(InputField, {
    name: name,
    placeholder: placeholder,
    errors: errors,
    touched: touched,
    type: type,
    onChange: onChange,
    onBlur: onBlur,
    fw: fw,
    value: value
  }));
};
InputWithLabel.defaultProps = {
  errors: {},
  touched: {},
  type: "text"
};
InputWithLabel.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  touched: PropTypes.object,
  errors: PropTypes.object,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any
};

export { InputWithLabel as default };
